import { render, staticRenderFns } from "./XiaoChengXuMa.vue?vue&type=template&id=6451b518&"
import script from "./XiaoChengXuMa.vue?vue&type=script&lang=js&"
export * from "./XiaoChengXuMa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports